// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DefaultListSectionSeparatorProps,
  PlasmicListSectionSeparator,
} from "@/wab/client/plasmic/plasmic_kit_design_system/PlasmicListSectionSeparator";
import * as React from "react";
import { useSeparator } from "react-aria";

interface ListSectionSeparatorProps extends DefaultListSectionSeparatorProps {
  style?: React.CSSProperties;
}

function ListSectionSeparator(props: ListSectionSeparatorProps) {
  const { separatorProps } = useSeparator({
    elementType: "li",
  });

  return (
    <PlasmicListSectionSeparator
      {...props}
      root={{
        as: "li",
        props: separatorProps,
      }}
    />
  );
}

export default ListSectionSeparator;
